import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminArticles from "@/pages/admin/AdminArticles";

export const Route = createFileRoute("/admin/articles/")({
  component: () => (
    <ProtectedRoute>
      <AdminArticles />
    </ProtectedRoute>
  ),
});
